import React from 'react';
import ankit from './ankit.jpg';
import venkat from './venkat.jpg';
import ajay from './ajay.jpg';
import ankitWeight from './ankit-weigth.svg';
import venkatWeight from './venkat-weight.svg';
import ajayWeight from './ajay-weight.svg';

const SuccessStories = () => {

    return(
        <div className='succes-stories pt-4 mt-0'>
            <h2 className='mb-0'>Success stories</h2>
            <h5 className='mb-3'>Get inspired and see their success</h5>
            <div className='diet-scrolling-wrapper-flexbox'>
                <div className='doctor-slide'>
                    {/* <ReactCompareSlider
                        itemOne={<ReactCompareSliderImage src={ankitbefore} alt="Image one" />}
                        itemTwo={<ReactCompareSliderImage src={ankitafter} alt="Image two" />}
                    /> */}
                    <img src={ankit} alt='' className='w-100' />
                    <div className="d-flex align-items-middle mt-3">
                        <div>
                            <h5 className='user-name mb-0'>Ankit</h5>
                            <p className='user-description mb-0'>Lost 15 kgs</p>
                        </div>
                        <img className="ms-2" src={ankitWeight} alt='' />
                    </div>
                    {/* <p className='user-text mt-2 mb-5'>Their entire process was excellent because everyday I used to have a call with my dietician. It was like a dream come true. I feel energetic.</p> */}
                </div>
                <div className='doctor-slide mb-4'>
                    {/* <ReactCompareSlider
                        itemOne={<ReactCompareSliderImage src={ankitbefore} alt="Image one" />}
                        itemTwo={<ReactCompareSliderImage src={ankitafter} alt="Image two" />}
                    /> */}
                    <img src={venkat} alt='' className='w-100' />
                    <div className="d-flex align-items-middle mt-3">
                        <div>
                            <h5 className='user-name mb-0'>Venkat</h5>
                            <p className='user-description mb-0'>Lost 9 kgs</p>
                        </div>
                        <img className="ms-2" src={venkatWeight} alt='' />
                    </div>
                    {/* <p className='user-text mt-2 mb-5'>Their entire process was excellent because everyday I used to have a call with my dietician. It was like a dream come true. I feel energetic.</p> */}
                </div>
                <div className='doctor-slide mb-4'>
                    {/* <ReactCompareSlider
                        itemOne={<ReactCompareSliderImage src={ankitbefore} alt="Image one" />}
                        itemTwo={<ReactCompareSliderImage src={ankitafter} alt="Image two" />}
                    /> */}
                    <img src={ajay} alt='' className='w-100' />
                    <div className="d-flex align-items-middle mt-3">
                        <div>
                            <h5 className='user-name mb-0'>Ajay</h5>
                            <p className='user-description mb-0'>Lost 6 kgs</p>
                        </div>
                        <img className="ms-2" src={ajayWeight} alt='' />
                    </div>
                    {/* <p className='user-text mt-2 mb-5'>Their entire process was excellent because everyday I used to have a call with my dietician. It was like a dream come true. I feel energetic.</p> */}
                </div>
               
            </div>
            
        </div>
    );
}

export default SuccessStories;